<template>
  <pt-doctor-detail class="pt-doctor-detail__withData" :detail="detail" :userId="userId" :userFullName="userFullName"></pt-doctor-detail>
</template>

<script>
import PtDoctorDetail from './index'
export default {
  name: 'pt-doctor-detail__withData',
  components: {
    'pt-doctor-detail': PtDoctorDetail
  },
  data () {
    return {
      detail: {},
      userId: '',
      userFullName: ''
    }
  },
  methods: {
    getDetail () {
      this.$store.dispatch('getDoctorDetail', this.$route.params.id).then(ret => {
        this.detail = ret
        if (this.detail.userLogin) {
          this.$store.dispatch('getUserByLogin', this.detail.userLogin).then(res => {
            this.userId = res.data.id
            this.userFullName = res.data.fullName
          }).catch(err => {
            console.log(err)
          })
        }
      }).catch(err => {
        this.$message.error(err || '获取医生详情失败')
      })
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
